import React, { useState, useCallback } from 'react';
import AchievementDetailModal from './AchievementDetailModal';
import AchievementImage from './AchievementImage';

const AchievementCard = ({ achievement, onMarkNotified, isPublicView = false }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const getRequirementText = () => {
    return achievement.description;
  };

  const handleCardClick = () => {
    setShowModal(true);
    setShowTooltip(false); // Hide tooltip when modal opens
    // Also mark as notified if it's a new unlocked achievement
    if (achievement.unlocked && !achievement.notified && onMarkNotified) {
      onMarkNotified([achievement.id]);
    }
  };

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <div 
      className={`achievement-grid-card ${achievement.unlocked ? 'achievement-grid-card--unlocked' : 'achievement-grid-card--locked'}`}
      onClick={handleCardClick}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {achievement.unlocked && !achievement.notified && !isPublicView && (
        <div className="achievement-grid-card__new-badge">NEW</div>
      )}
      
      <div className="achievement-grid-card__image-container">
        <AchievementImage
          filename={achievement.image_filename}
          alt={achievement.name}
          className={`achievement-grid-card__image ${!achievement.unlocked ? 'achievement-grid-card__image--locked' : ''}`}
        />
        
        {!achievement.unlocked && (
          <div className="achievement-grid-card__lock-overlay">
            <img
              src="/achievements/locked/Locked.png"
              alt="Locked"
              className="achievement-grid-card__lock-icon"
            />
          </div>
        )}
      </div>
      
      {showTooltip && (
        <div className="achievement-tooltip">
          <div className="achievement-tooltip__content">
            <h4 className="achievement-tooltip__name">{achievement.name}</h4>
            <p className="achievement-tooltip__requirement">{getRequirementText()}</p>
          </div>
        </div>
      )}

      <AchievementDetailModal
        key={`modal-${achievement.id}`}
        achievement={achievement}
        isOpen={showModal}
        onClose={handleCloseModal}
        isPublicView={isPublicView}
      />
    </div>
  );
};

export default AchievementCard;